<div class="amnt-field">
  <label [for]="id" [id]="id">{{ label }}</label>
  <div class="amnt-input">
    <span class="dollar">$</span>
    <input
      class="ods-text-input"
      [attr.aria-label]="label"
      appDecimalNumberFormat
      pattern="^\d+(\.\d+)?$"
      type="text"
      [id]="id"
      autocomplete="off"
      (keypress)="validateDecimal($event)"
      maxlength="9"
      [value]="value"
      (input)="handleInput($event)"
      (blur)="onTouched()"
    />
  </div>
  <p *ngIf="value && !isValid" class="error-message" aria-live="polite">
    Please enter a valid value
  </p>
</div>
